import * as yup from 'yup';
import { ngnRegistrationNumberRegex } from '../constant';

const kybUpdateBusinessInfoSchema = yup.object().shape({
  businessName: yup.string().required('Business name is required'),
  email: yup
    .string().trim()
    .email('Enter a valid email')
    .required('Email is required'),
  description: yup
    .string()
    .required('Description is required')
    .max(1000, 'Description cannot be more than 20 characters'),
  website: yup
    .string()
    .url('Enter a valid URL')
    .required('Website is required'),
  registrationNumber: yup
    .string()
    .required('Registration number is required')
    .test(
      'is-correct-business-name',
      'Must start with BC- or RC- followed by a 7 digit number',
      (value) => !!value && ngnRegistrationNumberRegex.test(value),
    ),
  businessType: yup.string().required('Business type is required'),
  countryName: yup.string().required('Country is required'),
});

const kybUpdateValidationSchemas = [kybUpdateBusinessInfoSchema];

export default kybUpdateValidationSchemas;
